import Photos from './PhotosContainer';

export default Photos;
